import React, { useState, useCallback } from 'react';
import Form from 'js/components/common/Form';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import { Input } from 'js/components/common/Fields/Input';
import { required } from 'js/utils/Validation/validationRules';
import { useLoginPopup } from 'js/components/popups/LoginPopup';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

import { usePinVerification } from './hooks';

import style from './PinVerification.scss';

const validationConfig = {
    pin: [
        required({ error: 'playtech.mobile.system.pinVerification.popup.pin.tooltip.required' })
    ]
};

export const PinVerification = ({ isSSO, onSuccess, onClose }) => {
    const [error, setError] = useState();
    const showLoginPopup = useLoginPopup();
    const pinVerification = usePinVerification({ onSuccess, onClose, setError });

    const returnToLogin = useCallback((event) => {
        event.preventDefault();
        onClose();

        if (isSSO) {
            showLoginPopup();
        }
    }, [showLoginPopup, onClose, isSSO]);

    const t = useTranslations('playtech.mobile.system.pinVerification.popup.');

    return <Form
        onSubmit={pinVerification}
        validationConfig={validationConfig}
        render={({ submitting, handleSubmit }) => (
            <div>
                <form onSubmit={event => event.preventDefault()}>
                    {error && (
                        <ErrorMessage
                            error={error}
                            animate={true}
                            className={style.error}
                        />
                    )}
                    <span className={style.description}>{t('title')}</span>
                    <Input
                        name="pin"
                        type="password"
                        className={style.control}
                        placeholder={t('pin.placeholder')}
                        aria-label={t(['pin.placeholder', 'playtech.mobile.system.input.aria-label'])}
                    />
                    <span>
                        {t('forgotPin')} <a href="#" onClick={returnToLogin}>{t('return')}</a>
                    </span>
                    <div className={style.formActions}>
                        <Button
                            type="button"
                            color="negative"
                            onClick={onClose}
                            className={style.btn}
                        >
                            {t('playtech.mobile.system.cancel.button.title')}
                        </Button>
                        <Button
                            type="button"
                            className={style.btn}
                            disabled={submitting}
                            onClick={handleSubmit}
                        >
                            {t('button.verify')}
                        </Button>
                    </div>
                </form>
            </div>
        )}
    />;
};
